export default "__VITE_ASSET__8b9ca982__"